<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button @click="$utils.goBack($router)"
            text="Quay lại"
            defaultHref="/tabs/main"
          ></ion-back-button>
        </ion-buttons>
        <ion-title>Nạp xu</ion-title>
        <ion-label slot="end" style="margin-right: 2vw"></ion-label>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <div style="margin-bottom: 2vh">
        <h4>Phương thức nạp khuyến nghị</h4>
      </div>
      <div class="cards">
        <div>
          <div
            class="card ion-activatable"
            @click="router.push('/account/deposit/bank')"
            style="overflow: hidden"
          >
            <ion-ripple-effect></ion-ripple-effect>
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div style="width: 12vw">
                <img :src="require('../../../images/account/bank.png')" />
              </div>
              <div>
                <h3>Chuyển khoản ngân hàng</h3>
              </div>
            </div>
          </div>

          <div style="text-align: center; font-size: 1.1em; margin: 1vh">
            5 giây-15 phút (duyệt nhanh đến 1 triệu)
          </div>
          <div
            style="
              text-align: center;
              font-size: 1.1em;
              font-weight: bold;
              margin: 1vh;
            "
          >
            Cùng ngân hàng, không mất phí
          </div>
        </div>

        <div style="margin-top: 2vh">
          <ion-list>
            <ion-item lines="full" @click="toggleExt()">
              <ion-label> Dùng thẻ tín dụng, VISA, Mastercard.. </ion-label>
              <ion-icon :icon="remove" slot="end" v-if="showExt"></ion-icon>
              <ion-icon :icon="add" slot="end" v-else></ion-icon>
            </ion-item>
            <ion-item lines="full" v-if="showExt" button @click="cashierOpen">
              <div style="max-width: 25vw" slot="start">
                <img :src="require('../../../images/account/vnpay_qr.png')" />
              </div>
              <ion-label>
                  Cổng thanh toán VNPAY
              </ion-label>
            </ion-item>
          </ion-list>
          <div></div>
        </div>
      </div>
      <support-button></support-button>
    </ion-content>
  </ion-page>
</template>

<style scoped>
.balance {
  padding: 2vw;
  border-bottom: 1px solid #bbb;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cards {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 2vh;

}

.cards .card {
  position: relative;
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: column;
  padding: 2vw;
  border: 1px solid #bbb;
  border-radius: 10px;
  box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.5);
}

.cards .card div {
  margin: 2vw;
}
</style>

<script>
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
import { add, remove } from 'ionicons/icons';
import {
  IonPage,
  IonContent,
  IonHeader,
  IonButtons,
  IonBackButton,
  IonTitle,
  IonToolbar,
  IonRippleEffect,
  IonLabel,
  IonList,
  IonItem,
  IonIcon,
} from "@ionic/vue";
// import { Plugins } from "@capacitor/core";
import SupportButton from "@/components/SupportButton.vue";

export default defineComponent({
  name: "PaymentDeposit",
  components: {
    IonRippleEffect,
    IonPage,
    IonContent,
    IonHeader,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonToolbar,
    IonLabel,
    IonList,
    IonItem,
    IonIcon,
    SupportButton,
  },
  setup() {
    const router = useRouter();
    const showExt = ref(false);
    return {
      router,
      showExt,
      add,
      remove,
      toggleExt() {
        showExt.value = !showExt.value;
      },
      async cashierOpen() {
        // const { Browser } = Plugins;
        // await Browser.open({ url: 'https://cashier.gimolott.vn/order/create_payment_url' });
        router.push("/account/deposit/packages");
      },
    };
  },
});
</script>
